import { __styles, mergeClasses, shorthands, tokens, typographyStyles } from '@fluentui/react-components';
export const sensitivityLabelClassNames = {
  root: 'fai-SensitivityLabel',
  label: 'fai-SensitivityLabel__label',
  tooltip: 'fai-SensitivityLabel__tooltip'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {},
  label: {
    mc9l5x: "ftuwxu6",
    Beiy3e4: "f1063pyq",
    Bt984gj: "f122n59",
    Bqenvij: "f11p92ab",
    Bbmb7ep: ["f1aa9q02", "f16jpd5f"],
    Beyfa6y: ["f16jpd5f", "f1aa9q02"],
    B7oj6ja: ["f1jar5jt", "fyu767a"],
    Btl43ni: ["fyu767a", "f1jar5jt"],
    sj55zd: "f11d4kpn",
    De3pzq: "f3vzo32",
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcpl73t",
    z8tnut: "f1g0x7ka",
    z189sj: ["fdw0yi8", "fk8j09s"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["fk8j09s", "fdw0yi8"]
  },
  tooltip: {}
}, {
  d: [".ftuwxu6{display:inline-flex;}", ".f1063pyq{flex-direction:row;}", ".f122n59{align-items:center;}", ".f11p92ab{height:var(--lineHeightBase300);}", ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}", ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}", ".f11d4kpn{color:var(--colorNeutralForeground3);}", ".f3vzo32{background-color:var(--colorNeutralBackground5);}", ".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcpl73t{line-height:var(--lineHeightBase100);}", ".f1g0x7ka{padding-top:0;}", ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}", ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}", ".f1qch9an{padding-bottom:0;}"]
});
/**
 * Apply styling to the SensitivityLabel slots based on the state
 */
export const useSensitivityLabelStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityLabelClassNames.root, styles.root, state.root.className);
  if (state.label) {
    state.label.className = mergeClasses(sensitivityLabelClassNames.label, styles.label, state.label.className);
  }
  if (state.tooltip) {
    state.tooltip.className = mergeClasses(sensitivityLabelClassNames.tooltip, styles.tooltip, state.tooltip.className);
  }
  return state;
};
//# sourceMappingURL=useSensitivityLabelStyles.js.map